'use strict';

/**
 * @name Novicell Gallery
 * @desc Gallery, for custom arrow use https://flickity.metafizzy.co/options.html#arrowshape
 * @author Emil Ankersen (EAN)
 * @requires https://flickity.metafizzy.co/
 */


var novicell = novicell || {};

novicell.gallery = novicell.gallery || new function () {

    this.init = function () {
        const gallery = document.querySelector('.js-gallery');
        const productPage = document.querySelector('.js-product-page');
        const casePage = document.querySelector('.js-case-page');
        const galleryNav = document.querySelector('.js-gallery-nav');
        const galleryItem = document.querySelectorAll('.gallery__item');
        const linkHolder = document.querySelector('.js-gallery-item-link');
        const nameHolder = document.querySelector('.js-gallery-item-name');
        if (productPage) {
            let flktyGallery = new Flickity(gallery, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                bgLazyLoad: 1,
                wrapAround: true,
                cellSelector: '.gallery__item',
                prevNextButtons: true,
                arrowShape: {
                    x0: 20,
                    x1: 70, y1: 50,
                    x2: 80, y2: 40,
                    x3: 40
                }
            });
        }

        if (casePage) {
            let flktyGallery = new Flickity(gallery, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                bgLazyLoad: 1,
                wrapAround: true,
                cellSelector: '.gallery__item',
                prevNextButtons: true,
                arrowShape: {
                    x0: 20,
                    x1: 70, y1: 50,
                    x2: 80, y2: 40,
                    x3: 40
                },
                on: {
                    change: function (index) {
                        let itemName = galleryItem[index].getAttribute('data-name');
                        let itemLink = galleryItem[index].getAttribute('data-link');
                        linkHolder.setAttribute('href', itemLink);
                        nameHolder.innerHTML = itemName;
                    }
                }
            });
        }

        // Gallery nav
        if (galleryNav && galleryNav != null) {
            let flktyGalleryNav = new Flickity(galleryNav, {
                bgLazyLoad: 1,
                asNavFor: gallery,
                contain: true,
                pageDots: false,
                cellAlign: 'left',
                groupCells: true,
            });
        }

        // Scroll to case list
        const scrollTrigger = document.querySelector('.js-scroll-trigger');
        const target = document.querySelector('.js-case-list');
        if (scrollTrigger != null && target != null) {
            scrollTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                window.scrollTo({
                    'behavior': 'smooth',
                    'left': 0,
                    'top': target.offsetTop - 50
                });
            }, true);
        }
    };
}();
